import { useQuery } from '@tanstack/react-query';
import { faro } from '@grafana/faro-web-sdk';
import { useClient } from './useClient';

import {
  GetFunctionsQuery,
  GetFunctionsResponse,
} from '@hud/portal-dtos/webapp-function.dto';
import { PORTAL_BASE } from '../consts';

export const SERVICE_FUNCTIONS_ID = 'function-services';

export default function useServiceFunctions(
  serviceId?: number,
  params?: GetFunctionsQuery,
) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SERVICE_FUNCTIONS_ID, serviceId, params],
    queryFn: async () => {
      const startTime = new Date();
      const response = await client.get<GetFunctionsResponse>(
        `${PORTAL_BASE}/services/${serviceId}/functions`,
        { params },
      );
      faro.api.pushMeasurement({
        type: 'getFunctions',
        values: {
          time: new Date().getTime() - startTime.getTime(),
        },
      });
      return GetFunctionsResponse.parse(response.data);
    },
    enabled: isReady && params?.environmentName !== undefined,
  });
}
